module.exports = __webpack_public_path__ + "precision-ocr-logo.99e1785ae17f74ba20453fd2c0228f15.svg";